module.exports = __webpack_public_path__ + "build/img/role_cluji.0632b7d1.png";